const middleware = {}

middleware['accountManagementGuard'] = require('../middleware/accountManagementGuard.ts')
middleware['accountManagementGuard'] = middleware['accountManagementGuard'].default || middleware['accountManagementGuard']

middleware['accountSetupGuard'] = require('../middleware/accountSetupGuard.ts')
middleware['accountSetupGuard'] = middleware['accountSetupGuard'].default || middleware['accountSetupGuard']

middleware['authGuard'] = require('../middleware/authGuard.ts')
middleware['authGuard'] = middleware['authGuard'].default || middleware['authGuard']

middleware['contact-upload'] = require('../middleware/contact-upload.ts')
middleware['contact-upload'] = middleware['contact-upload'].default || middleware['contact-upload']

middleware['errorRouteGuard'] = require('../middleware/errorRouteGuard.ts')
middleware['errorRouteGuard'] = middleware['errorRouteGuard'].default || middleware['errorRouteGuard']

middleware['hasPermissionToEditCampaign'] = require('../middleware/hasPermissionToEditCampaign.ts')
middleware['hasPermissionToEditCampaign'] = middleware['hasPermissionToEditCampaign'].default || middleware['hasPermissionToEditCampaign']

middleware['hotjar'] = require('../middleware/hotjar.ts')
middleware['hotjar'] = middleware['hotjar'].default || middleware['hotjar']

middleware['hubspot'] = require('../middleware/hubspot.ts')
middleware['hubspot'] = middleware['hubspot'].default || middleware['hubspot']

middleware['initialiseCampaign'] = require('../middleware/initialiseCampaign.ts')
middleware['initialiseCampaign'] = middleware['initialiseCampaign'].default || middleware['initialiseCampaign']

middleware['payAsYouGoGuard'] = require('../middleware/payAsYouGoGuard.ts')
middleware['payAsYouGoGuard'] = middleware['payAsYouGoGuard'].default || middleware['payAsYouGoGuard']

export default middleware
